module.exports = __webpack_public_path__ + "static/img/berthAnalyze-header.646c2e0a.png";